export enum RowBackgroundColorSetBy {
  Banded = 'Banded',
  Classification = 'Classification',
  Forced = 'Forced'
}
